export * from './geolocate-button.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/geolocate-button/index.ts